import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const zh_CN = {
  "home":{
    "bgTitle1":"一个账号即可获得所有Lenovo内容",
    "bgTitle2":"一个账号。在一个位置完成全部管理。欢迎使用账号仪表板",
    "login":"登录",
    "register":"创建您的联想账号",
    "help":"帮助",
    "legal":"使用条款",
    "privacy":"隐私声明",
    "lenovoVip":"联想会员",
    "lenovoVipText":"联想为向核心用户提供更优质的购物体验，特别推出联想会员服务，包括注册送新手礼包、每月优惠券礼包、购物返乐豆、会员价商品、每日延保特权、游戏特权等11项专属特权，全方位提升服务体验。",
    "accountSecurity":"账号安全",
    "accountSecurityText":"保护您的Lenovo ID的安全，提供多种方法来保护您的Lenovo ID 和隐私，这些方法包括及时更改密码，绑定安全手机和邮箱，设置密码保护等。",
    "singleSign":"单点登录",
    "singleSignText":"只需要一个账号，就可以畅享多个联想的服务和应用，还有联想和合作伙伴提供的专属或扩展功能。",
    "lenovoHelp":"帮助",
    "lenovoHelpText":"获得联想产品和服务方面的专业服务和帮助。",
    "more":"了解更多",
  },
  "help":{
    "Note":"注：如果邮箱收件箱中没有验证码邮件，请检查垃圾箱中的邮件",
    "accountAppeal":  "账号申诉",
    "appealAccount":  "申诉账号:",
    "findAccount": "找回账号",
    "submitApplications": '如您账号被盗或手机号和邮箱不再使用无法收到验证码，请提交申请等待审批。',
    "submitButton": '提交申请',
    "backPrevious": '返回上一页',
    "back": '返回',
    "nextStep": '下一步',
    "progressQuery": '申请进度查询',
    "appeal": '发起申诉',
    "contactInfor": '联系方式',
    "accountInfor": '账号资料',
    "completeAppeal":'完成申诉',
    "appealPrompt1": '1、申诉可以找回被盗账号，解决无法正常修改密码保护问题等情况。',
    "appealPrompt2": '2、申诉结果通常会在3个工作日内发送到你留下的邮箱，请注意查收。',
    "businessType": '业务类型:',
    "placeholder1": '邮箱或手机号',
    "gameUsers": '游戏用户',
    "enterGrievanceAccount": '请输入申诉账号',
    "enterEmail1": '请输入邮箱',
    // "incorrectEP": '邮箱格式或手机号格式不正确',
    "incorrectEP": '邮箱格式不正确',
    "againFill": '此账号已提交申诉，请勿重复填写。',
    "contactFill": '填写接收申诉结果的联系方式',
    "contactDetails": '联系方式:',
    "ContactEmail": '联系邮箱:',
    "appealResult": '此邮箱用于接收申诉结果',
    "code": '验证码:',
    "basicAccountInfor": '账号基本信息',
    "usedEmail": '曾用邮箱:',
    "usedphone": '曾用手机:',
    "registrationTime": '注册时间:',
    "name": '真实姓名:',
    "idNumber": '证件号码:',
    "idPhoto": '证件照片:',
    "enterUsedEmail": '请填写您曾绑定过的邮箱',
    "enterUsedphone": '请填写您曾绑定过的手机号',
    "enterRegistrationTime": '请填写您账号的注册时间',
    "chineseName": '请输入您的中文真实姓名',
    "idName": '请输入18位身份证号',
    "upload": '点击上传',
    "uploadPhotos": '请分别上传身份证正反面照片',
    "imageExceed": '1.每张图片的大小不能超过2MB(2MB=2048KB)',
    "imageExceed2": '2.必须提供至少3笔订单截图，且包含游戏首笔及被盗前最后一笔支付订单，若累计充值不到3笔需提供全部消费订单，所提供的消费订单截图必须能看清商家订单号及支付时间',
    "imageExceed3": '3.没有游戏内充值的账号需要提供账号最开始注册时的验证码截图或者对应手机号的营业厅截图',
    "onlyUsed": '2.证件图片仅用于账号申诉时核实身份，绝无其他用途',
    "noId": '3.若无身份证，也可提供户口簿、护照、军官证、士兵证、港澳台通行证图片；',
    "accountUseInfor": '账号使用信息',
    "gameName": '游戏名称:',
    "gameName1": '游戏名称',
    "gameService": '游戏区服:',
    "gameService1": '游戏区服',
    "gameNicknames": '游戏内昵称:',
    "gameNicknames1": '游戏内昵称',
    "gameID": '游戏ID:',
    "gameID1": '游戏ID',
    "Gamename3": '所玩游戏名称',
    "rechargeOrder": '充值订单:',
    "otherInfor": '其他信息:',
    "service": "联系方式:",
    "cService": "客服QQ: 3007422129",
    "oService": "在线客服",
    "deliveryAddress": '收货地址:',
    "addressUsed": '请填写曾使用过的收货地址',
    "consumptionInfor": '消费信息:',
    "enterConsumptionInfor": '请填写您的消费信息',
    "douInfor": '乐豆信息:',
    "enterDouInfor": '请填写乐豆数量',
    "orderNo": '订单编号:',
    "enterOrderNo": '请输入订单编号',
    "addInfor": '补充信息:',
    "backupData": '备份数据类型:',
    "photoContact": '照片或联系人信息',
    "lastTime": '最后一次使用时间:',
    "enterLastTime": '请填写最后一次使用应用时间',
    "complaintAccepted": '申诉已受理',
    "photosBacked": '云服务中备份的照片:',
    "Previous": '上一步',
    "receiveEmail": '通过邮箱接收申诉结果',
    "enterEmail": '请输入您常用的邮箱',
    "enterCode": '填写验证码',
    "required": '*号为必填项',
    "workingDay": '申诉结果将在3个工作日内发送到您填写的联系邮箱',
    "workingDay7": '请勿重复提交账号申诉，如您申诉的账号存在多人同时申诉的情况，我们将在7个工作日内通知您申诉结果。',
    "done": '完成',
    "errEmail": '联系邮箱格式错误',
    "enterName": '请输入姓名',
    "incorrectEmail1": '邮箱格式不正确',
    "incorrectPhone": '手机号格式不正确',
    "enterNumber": '请输入证件号码',
    "idNumber18": '请输入18位证件号码',
    "enterGameName": '请输入游戏名称',
    "enterInGameName": '请输入游戏内名称',
    "enterZService": '请输入区服',
    "enterGameID": '请输入游戏ID',
    "onlyJpg": '上传图片格式仅支持jpg、png和jpeg!',
    "imageSize": '上传图片大小不能超过 2MB!',
    "twoImage": '上传图片不能超过2张!',
    "FileImage": '上传图片不能超过5张!',
    "errorImage": '上传图片失败!',
    "errorImage1": '上传图片名称字数超过限制!',
    "emptyEmail": '邮箱不可为空',
    "uploadId": '请上传您的证件',
    "uploadOrder": '请上传您的订单信息',
    "sure": '确定',
    "getCode": '获取验证码',
    "enterCode": '请输入验证码',
    "codeError": '验证码错误',
    "invalidCode": '验证码已失效',
    "upperLimit": '验证码发送次数已达上限',
    "emailNoAgain": '此邮箱已提交申诉，请勿重复填写',
    "phoneNoAgain": '此账号已提交申诉，请勿重复填写',
  },
  "appeal": {
    "idResult": '联想账号申诉结果',
    "bindInfor": '请输入您需要绑定的信息',
    "SetPassword": '请设置您的登录密码',
    "successfulAppeal": '申诉成功，授权与验证',
    "chooseEmailP": '请选择您需要重置的安全信息',
    "securityInfor": '重置安全信息',
    "passAccount": '恭喜您通过账号申诉审核',
    "checkCode": '申诉系统已将授权码发送至您的联系邮箱中，请到您的联系邮箱中查收您的授权码',
    "recivedCode": '收到的授权码:',
    "enterAuthoriCode": '请输入授权码',
    "secureEmail": '重置安全邮箱',
    "changeInfor": '重置后可以使用此邮箱登录，并作为更改安全信息的身份验证方式',
    "reset": '重置',
    "resetPhone": '重置安全手机',
    "changePhone": '重置后可以使用此手机号登录，并作为更改安全信息的身份验证方式',
    "resetPassword": '重置密码',
    "completeSet": '完成设置',
    "enterGraphicCode": '输入图形验证码',
    "sentToEmail": '请输入上面显示的字符，然后单击下面的按钮。验证码将发送至您的邮箱',
    "getVCode": '获取邮箱验证码',
    "resend": '重新发送',
    "enterEmailVerCode": '请输入邮箱验证码',
    "pEnterGraphicCode": '请输入图形验证码',
    "pEnterGraphicCode1": '请输入图形验证码 ',
    "requestAgain": '请求次数过多，请稍后重试',
    "verificationCodeError": '图形验证码错误',
    "verificationCodeError1": '图形验证码错误',
    "enterNewPassword": '输入新密码',
    "surePassword": '确认密码',
    "password8": '密码必须至少包含8-20个英文字符，并且至少包含以下三种:大写字母、小写字母、数字和符号。',
    "emptyCode": '密码不可为空',
    "twoInconsistencies": '两次输入不一致',
    "passwordNotRules": '密码不符合规则',
    "requestLocked": '请求被锁定',
    "newExists": '新用户已存在',
    "codeFrozen": '账号已被冻结',
    "vCodeError": '邮箱验证码错误',
    "cheackOk": '请查看所输入的信息是否正确',
    "enterAuthoriCode1": '您已超时，请重新访问重置链接输入授权码',
    "accountNotExist": '账号不存在',
    "emailSetUp": '您的安全邮箱已经设置完成',
    "returnHome": '秒后将自动返回首页',
    "accountSet": '您可以进行与账号安全相关的设置',
    "enterPhoneCode": '请输入手机号',
    "SentToPhone": '请输入上面显示的字符，然后单击下面的按钮。验证码将发送至您的手机',
    "SMSCode": '请输入短信验证码',
    "authorizationError": '授权码错误',
    "ACodeExpired": '授权码过期',
    "enterNewPassword": '输入新密码',
    "SmSError": '短信验证码错误',
    "phoneSetUp": '您的安全手机已经设置完成',
    "linkExpired": '链接已过期，请重新填写申诉表单',
    "note1": '注：所绑定的手机号或邮箱必须真实有效并且没有注册过LenovoID'
  },
  "freezing":{
    "AccountEnable": '账号解冻',
    "confirmInfor": '请确认账号信息',
    "accountDisabled": '账号冻结',
    "successActiviva": '解冻成功',
    "disableSuccess": '冻结成功',
    "currentDisabled": '当前账号已被冻结，请确认是否解冻',
    "UID": 'UID(联想账号唯一标识) :',
    "currentName": '当前账号用户名 :',
    "note": '注 : 冻结该账号后，用户将无法进行任何操作',
    "no": '否',
    "yes": '是',
    "linkExpired": '此链接已失效，无法进行操作',
  },
  "security":{
    "linkSecurity": '生成重置安全信息链接:',
    "linkAccount": '生成账号冻结/解冻链接:',
    "UserId": '请输入UserID',
    "submit": '提交',
    "optionNempty": '选项不能为空',
    "resetSecurity": '申请重置安全信息',
    "applyInformation": '请填写下列信息并提交',
    "applyAccepted": '申请已受理',
    "userEmail": '请在工单系统中查看详细内容，并将重置安全信息链接发送至用户的联系邮箱 ',
    "userIDInvalid": "UserID无效",
    "notSubmit": '此账号未提交申诉',
    "notMatch": '联系邮箱与申诉账号不匹配',
    "access": '您无权访问此页面',
  },
  ...enLocale
}

export default zh_CN



// WEBPACK FOOTER //
// ./src/i18n/language/zh_CN.js